<template>
  <section class="container">
    <transition name="overlay-fade">
      <div class="" v-show="processed">
        <header class="dialog-header">
          <h1>Gepubliceerd</h1>
        </header>
        <div class="dialog-content">
          <p class="holder-text">
            Uw ontwerp <strong>{{ title }}</strong> is voor alle gebruikers van
            deze portal te vinden via: {{ rootStore.theme.printStore.name }} >
            {{ savedCollectionName }}
          </p>
          <div class="button-holder">
            <button
              type="button"
              class="pill-button secondary"
              @click="$emit('close')"
            >
              Sluiten
            </button>
            <button class="pill-button" @click="goToProduct">
              Bekijken
            </button>
          </div>
        </div>
      </div>
    </transition>
    <template v-if="!processed">
      <header class="dialog-header">
        <h1>Bewaren en publiceren</h1>
      </header>
      <div class="dialog-content">
        <form
          @submit.prevent="save"
          id="save-form"
          name="saveForm"
          method="post"
          action="/save"
        >
          <p class="holder-text">
            Geef uw ontwerp een herkenbare naam.
          </p>

          <div>
            <label for="design">Naam ontwerp</label>
            <input
              id="design"
              type="text"
              name="design"
              required
              ref="input"
              v-model="title"
              class="grey-field"
              maxlength="256"
            />
            <div v-if="!$v.title.hasNoUrls" class="error">
              Let op, de naam mag geen URL bevatten.
            </div>
          </div>

          <p>
            Let op, uw ontwerp is voor alle gebruikers van deze portal zichtbaar
            en te bestellen.
          </p>

          <div class="button-holder">
            <template v-if="!processing">
              <button
                type="button"
                class="pill-button secondary"
                @click="$emit('close')"
              >
                Annuleren
              </button>
              <button
                class="pill-button"
                type="submit"
                :disabled="$v.title.$invalid"
              >
                Publiceren
              </button>
            </template>
            <bouncing-spinner
              class="spinner-ct"
              v-if="processing"
            ></bouncing-spinner>
          </div>
        </form>
      </div>
    </template>
  </section>
</template>

<script>
import { sendMail } from '@/api/api'
import { publishCustomProduct } from '@/features/printstore/PrintStoreApi'
import { required, maxLength, minLength } from '@vuelidate/validators'

function containsUrls(value) {
  const urlRegex = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/
  return urlRegex.test(value)
}

export default {
  props: ['callback', 'customProductSpecs'],
  data() {
    return {
      title: '',
      processing: false,
      processed: false,
      savedCollectionName: '',
      savedCollectionId: '',
      savedCategoryId: '',
      savedProductId: ''
    }
  },
  validations: {
    title: {
      hasNoUrls: (value) => !containsUrls(value),
      minLength: minLength(1),
      maxLength: maxLength(256),
      required
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.input.focus())
  },
  methods: {
    save() {
      this.processing = true
      const specs = {
        ...this.customProductSpecs,
        title: this.title
      }
      publishCustomProduct(specs).then((response) => {
        this.processing = false
        this.processed = true

        this.savedProductId = response.productId
        this.savedCollectionName = response.collectionName
        this.savedCollectionId = response.collectionId
        this.savedCategoryId = response.categoryId

        sendMail({
          to: 'camiel@rijnja.nl',
          subject: 'Custom product opgeslagen',
          message: `User ${this.rootStore.user.username} heeft product <strong>${this.title}</strong> bewaard in PrintStore <strong>${this.rootStore.theme.printStore.name}</strong>`,
          userInfo: {
            email: this.rootStore.user.username
          }
        })
      })
    },
    goToProduct() {
      this.$router.push({
        name: 'printStoreProduct',
        params: {
          categoryId: this.savedCategoryId,
          collectionId: this.savedCollectionId,
          productId: this.savedProductId
        }
      })
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../../sass/base/_colors.scss' as *;

label {
  font-weight: 300;
  line-height: 31px;
  margin-right: 10px;
}

input {
  width: 250px;
  margin: 0 0 8px 0;
}

button.secondary {
  margin-right: 5px;
}

.button-holder {
  height: 30px;
}

.spinner {
  padding: 5px;
}

.error {
  color: $rijnja-red;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
